import { inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { concatLatestFrom } from '@ngrx/operators'
import { signalStore, withHooks, withMethods, withProps } from '@ngrx/signals'
import { rxMethod } from '@ngrx/signals/rxjs-interop'
import { pipe, switchMap, tap } from 'rxjs'

import { ActionCableService } from './action-cable.service'

export const UserChannelStore = signalStore(
  { providedIn: 'root' },
  withProps(() => {
    const _channel$ = inject(ActionCableService).getChannel('UserChannel')

    return {
      _channel$,
      messages$: _channel$.pipe(switchMap(channel => channel.messages$)),
      reconnect$: _channel$.pipe(switchMap(channel => channel.reconnects$)),
    }
  }),
  withMethods(store => ({
    performTyping: rxMethod<{ profile_browse_id: string }>(
      pipe(
        concatLatestFrom(() => store._channel$),
        tap(([{ profile_browse_id }, channel]) => {
          channel?.perform('conversation_start_typing', {
            profile_browse_id,
          })
        }),
      ),
    ),
    performMarkAsRead: rxMethod<{ message_timestamp: string; profile_browse_id: string }>(
      pipe(
        concatLatestFrom(() => store._channel$),
        tap(([{ message_timestamp, profile_browse_id }, channel]) => {
          channel?.perform('conversation_read', {
            message_timestamp,
            profile_browse_id,
          })
        }),
      ),
    ),
  })),
  withHooks({
    onInit: store => {
      store._channel$.pipe(takeUntilDestroyed()).subscribe()
    },
  }),
)
